import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=26cf6d0a&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=26cf6d0a&prod&scoped=true&lang=css&"
import style1 from "./Faq.vue?vue&type=style&index=1&id=26cf6d0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cf6d0a",
  null
  
)

export default component.exports